export const translations = {
  'es-ES': {
    translation: {
      addUser: 'Agregar usuario',
      editUser: 'Editar usuario',
      firstName: 'Nombre',
      lastName: 'Apellidos',
      name: 'Nombre',
      role: 'Función',
      status: 'Estado',
      email: 'Correo electrónico',
      phone: 'teléfono',
      type: 'Tipo',
      details: 'Detalles',
      nodes: 'Nodos',
      roles: 'Roles',
      cancel: 'Cancelar',
      submit: 'enviar',
      delete: 'Eliminar',
      create: 'Crear',
      deleteNodeError: 'Error al eliminar nodo',
      deleteConfirmation: '¿Seguro que desea borrar?',
      warning: 'Advertencia',
      Alert: 'Alerta',
      deleteSure: 'Sí, estoy seguro',
      nodesWillBeCreatedAt: 'Los nodos se crearán en',
      searchFor: 'Buscar',
      rolesError: 'Error al recuperar funciones',
      userListError: 'Error al recuperar la lista de usuarios',
      organisationListError: 'Error al obtener la lista de organizaciones',
      loadingRoles: 'Cargando funciones...',
      selectRole: 'Seleccionar función',
      validEmail: 'Escriba una dirección de correo electrónico válida',
      requiredEmail: 'El correo electrónico es obligatorio',
      resend: 'Reenviar',
      restrictedDomain: 'Restricted email domain',
      addUserSuccess: 'El usuario se ha añadido correctamente',
      editUserSuccess: 'El usuario se ha editado correctamente',
      deleteUserSuccess: 'Usuario borrado correctamente',
      deleteModalAlertMessage:
        'Estás a punto de eliminar al usuario {{userName}}. Todos los permisos para el usuario serán revocados.',
      deleteProceedMessage: '¿Deseas proceder con la eliminación?',
      userAlreadyExist:
        'El usuario ya existe con este ID de correo electrónico.',
      addUserError: 'No se ha podido añadir el usuario. Inténtelo de nuevo.',
      editUserError: 'No se ha podido editar el usuario. Inténtelo de nuevo.',
      deleteUserError:
        'No se pudo eliminar al usuario. Por favor, inténtalo de nuevo.',
      nodesError: 'Error al recuperar los nodos asignados',
      childNodesError: 'Error al cargar los nodos secundarios',
      hierarchyError: 'Error al recuperar la jerarquía',
      requestFailed: 'Error de solicitud',
      emailSentSuccess:
        'Correo electrónico de activación enviado correctamente.',
      activationEmailError:
        'Error al enviar el correo electrónico de activación.',
      activationEmailError1:
        'No se pudo enviar el correo electrónico de activación. Inténtelo de nuevo más tarde.',
      allOrganisations: 'Todas las organizaciones',
      address: 'Dirección',
      hierarchyMetaError: 'Error al recuperar los detalles de la jerarquía',
      nodeMetaError: 'Error al cargar los detalles del nodo',
      contactName: 'Nombre del contacto',
      downloadTemplate: 'Descargar plantilla',
      newOrg: 'Nueva organización',
      save: 'guardar',
      upload: 'cargar',
      uploading: 'Cargando',
      dropExcel: 'Quitar hoja de Excel o',
      browse: 'examinar',
      importSettings: 'Importar configuración',
      addNodesSites: 'Añadir nuevos nodos/sitios',
      updateNodesSites:
        'Actualizar información sobre los nodos/sitios existentes',
      disableNodesSites: 'Deshabilitar nodos/sitios que ya no existen',
      disabled: 'Deshabilitado',
      new: 'Nuevo',
      updated: 'Actualizado',
      siteInstallation: 'Sitios',
      addOrgSuccess: '¡Organización creada con éxito!',
      excelUploadError: 'Error al guardar Excel. Inténtelo de nuevo.',
      saveError: 'Error al guardar. Inténtelo más tarde.',
      saveBadRequestError:
        'Error al guardar. Es probable que se trate de un problema con los datos que intentaba guardar.',
      telephone: 'teléfono',
      externalIds: 'ID externos',
      contactEmail: 'Correo electrónico de contacto',
      longitude: 'Longitud',
      latitude: 'Latitud',
      primaryContactName: 'nombre del contacto principal',
      primaryContactEmail: 'Correo electrónico de contacto principal',
      templateError: 'Error al cargar la plantilla. Inténtelo más tarde.',
      templateError1:
        'No se ha podido obtener la plantilla. Inténtelo más tarde.',
      home: 'Inicio',
      organisations: 'Organizaciones',
      users: 'Usuarios',
      lightTheme: 'Tema claro',
      darkTheme: 'Tema oscuro',
      login: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      activateUserAcc: 'Activar cuenta de usuario',
      phoneNumber: 'Teléfono',
      optional: 'opcional',
      password: 'Contraseña',
      confirmPassword: 'Confirmar contraseña',
      endUser: 'Contrato de licencia de usuario final',
      iAccept: 'Acepto el Contrato de licencia de usuario final.',
      iHereby: 'Confirmo por el presente documento que he leído y aceptado el',
      eula: 'CLUF',
      iRead: 'He leído la Política de privacidad de Honeywell',
      iUnderstood: 'Sí, he leído y comprendo la',
      privacyPolicy: 'Política de privacidad',
      activate: 'activar',
      activationSuccess: 'Activación correcta',
      newAccAccess:
        'Para acceder a su nueva cuenta, inicie sesión con su nuevo nombre de usuario. Este nuevo nombre de usuario se muestra a continuación:',
      emailSent:
        'Se ha enviado un nuevo nombre de usuario a su ID de correo electrónico.',
      signin: 'INICIAR SESIÓN',
      activationError: 'Error de activación',
      pleaseTryAgain: 'Inténtelo de nuevo',
      activationExpired: 'Token de activación expirado',
      activationExpiredText:
        'Esto puede deberse a que el enlace del correo electrónico ha caducado, ya ha sido utilizado o era incorrecto. Si el problema persiste, solicite un nuevo correo electrónico de activación.',
      contactSupport:
        'Error. Póngase en contacto con el servicio de asistencia técnica',
      pwdMatch: 'Las contraseñas deben coincidir',
      required: 'Obligatorio',
      eligiblePwd:
        'La contraseña debe contener al menos 1 letra mayúscula, 1 letra minúscula, 1 dígito, 1 carácter especial y al menos 11 caracteres',
      invalidPhoneNumber: 'Número de teléfono no válido',
      invalidName:
        'El nombre no debe tener más de 255 caracteres sin espacios iniciales ni finales',
      invalidFirstName: 'FirstName contains invalid characters.',
      invalidLastName: 'LastName contains invalid characters.',
      timezone: 'Zona horaria',
      timeZone: 'Zona horaria',
      commissioningStatus: 'estado de puesta en funcionamiento',
      countryCode: 'código de país',
      childCount: 'recuento de menores',
      sheetVersion: 'Versión de hoja',
      unknownError: 'Error desconocido. Inténtelo más tarde.',
      preview: 'vista previa',
      file: 'Archivo',
      inCompatibleExcel: 'El archivo debe estar en formato .xlsx.',
      selectOrg: 'Seleccionar organización',
      noRecordFound: 'No se han encontrado registros',
      total: 'Total',
      items: 'Artículos',
      forbidden: 'Prohibido',
      noPermissionText: 'No tiene permiso para acceder a esta página',
      accessPermission: 'Inicie sesión en una cuenta con permisos de acceso',
      technicianExternalAccessPermission:
        'Inicie sesión en la aplicación móvil',
      redirectToLogin: 'Redirigiendo a la página de inicio de sesión',
      errorUserSettings: 'Error al recuperar la configuración del usuario',
      invalidSystemGuid: 'GUID del sistema inválida',
      languageNotSupported: 'Idioma no admitido',
      subscriptions: 'Suscripciones',
      gatewayManagement: 'Gestión de puerta de enlace',
      subscriptionNumber: 'Número de suscripción',
      orderNumber: 'Número de pedido',
      bundle: 'Paquete',
      activatedOn: 'fecha de activación',
      order: 'pedido',
      editSubscription: 'Editar suscripción',
      noNodeSelected: 'No hay ningún nodo seleccionado',
      noUserSelected: 'No se ha seleccionado ningún usuario',
      loadingBundles: 'Cargando paquetes...',
      bundlesError: 'Error al recuperar paquetes',
      selectBundle: 'Seleccionar paquete',
      addSubscriptionSuccess: 'Suscripción añadida correctamente',
      addSubscriptionError:
        'No se pudo añadir la suscripción. Inténtelo de nuevo.',
      subscriptionInputValidationError:
        'puede ser un valor alfanumérico con un guion y no puede tener más de 13 caracteres',
      errorUserGlobalPrivileges:
        'Error al obtener privilegios globales de usuario',
      subscriptionAlreadyExist: 'La suscripción ya existe.',
      invalidSubscription: 'Suscripción inválida',
      Version: 'Versión',
      systemType: 'Tipo de sistema',
      systemId: 'ID del sistema',
      reviewGatewayDetails: 'Revisar los detalles de la puerta de enlace',
      site: 'Sitio',
      Organisation: 'Organización',
      gatewayRegistration: 'Registro de puerta de enlace',
      selectAnOrg: 'Seleccione una organización',
      selectASite: 'Seleccione un sitio',
      register: 'Registro',
      selectSiteToRegsiter:
        'Seleccione el sitio para registrar la puerta de enlace',
      gatewayRegistrationFailureMsg:
        'No se pudo registrar la puerta de enlace con la plataforma IOT de Honeywell Sentience',
      gatewayRegistrationSuccessMsg:
        'Gateway se ha registrado correctamente con la plataforma IOT de Honeywell Sentience',
      siteEmptyMsg:
        'Todos los sitios de la organización {{- orgName}} ya están registrados',
      forgeOnboarding: 'Mapa de la organización',
      SiteFetchingFailure: 'Error al obtener sitios desde Forge',
      selectAllSitesText:
        'Seleccionar todos los sitios de Forge que integrar en Remote Building Manager',
      onBoardingFailure: 'Error al iniciar la incorporación del sitio',
      customerID: 'ID de cliente',
      enterCustomerID: 'Introducir ID de cliente',
      loadingSites: 'Cargando sitios…',
      fetchSites: 'RECUPERAR SITIOS',
      subscriptionActivateSuccess:
        'La suscripción para "{{siteName}}" se ha activado correctamente',
      subscriptionActivateError:
        'No se puede activar debido a un problema técnico, comuníquese con su administrador',
      activateNow: 'Activar ahora',
      multiSiteSuccess: 'Los sitios se han agregado correctamente.',
      onboardSelected: 'Integración seleccionada',
      sitePartialSuccess:
        'Algunos sitios no se han podido integrar debido a un problema técnico. Inténtelo de nuevo o póngase en contacto con el administrador.',
      confirm: 'Confirmar',
      onboardingFailed: 'Error de incorporación',
      failed: 'Error',
      onboardedSuccessfully: 'Sitio incorporado',
      notOnboarded: 'No integrado',
      onboarding: 'Integrando...',
      reOnboard: 'Reintegración',
      selectAll: 'Seleccionar todo',
      siteSuccess: 'El sitio se ha añadido correctamente.',
      dataloseWarning:
        'No actualice la página mientras se están integrando los sitios.',
      addServiceSuccess: 'Servicios añadidos con éxito',
      addServicesText: 'Agregar servicios',
      validityText: 'Período de validez',
      invalidInputError: 'entrada inválida',
      subsactivateError: 'Suscripción ya activada',
      subsnotfoundError: 'Detalles de suscripción no encontrados',
      invalidorderError: 'Número de pedido no válido',
      bundnotfoundError: 'Detalles del paquete no encontrados',
      subscribedServices: 'SERVICIOS SUSCRITO',
      subsactivateSuccess: 'Suscripción creada y activada con éxito',
      subsactivateFailure:
        'Suscripción creada, pero la activación falló. Inténtalo de nuevo !!',
      subsactivateDiffSite: 'Suscripción ya activada para un sitio diferente',
      gatewayAssociation: 'Asociación de puerta de enlace',
      systemGuid: 'GUID del sistema',
      success: 'Éxito',
      contactSystemAdministrator:
        'Póngase en contacto con su administrador de sistemas',
      siteName: 'Nombre del sitio',
      location: 'Ubicación',
      action: 'Acción',
      addNewSite: 'Agregar nuevo sitio',
      add: 'Agregar',
      sitesAssociated: '{{siteCount}} Sitios Asociados',
      numberOfAddon: 'Number of Addon',
      searchSite: 'Buscar sitios',
      noResultFound: 'No se han encontrado resultados',
      noDataFound: 'No se encontraron datos',
      loadMore: 'Cargar más',
      unlinkMessage:
        'Para desvincular {{siteName}} de {{sku}}, comuníquese con el centro de atención al cliente de Honeywell (+01 480-353-3020) o envíe un correo electrónico a support@honeywell.com',
      associatedOrderNumber: 'Número de pedido asociado',
      associatedSubscriptionNumber: 'Número de suscripción asociado',
      helperTextSKU:
        'Para modificar el número de suscripción, póngase en contacto con',
      helperOrderTextSKU:
        'Para modificar el número de pedido, póngase en contacto con',
      customerCare: 'Atención al cliente',
      skuDetails: 'SKU Detalles',
      manageSites: 'Administrar sitios',
      skuName: 'SKU Nombre',
      skuDescription: 'SKU Descripción',
      licenseUtilization: 'Utilización de la licencia',
      validTill: 'Válida hasta',
      editSKU: 'Editar SKU',
      duplicateSiteError: 'El sitio ya está agregado',
      numberOfAddonRequired: 'Please enter Number of Addon',
      siteFetchError: 'Error al obtener la lista de sitios',
      siteSuccessMsg: 'Sitios añadidos correctamente',
      siteFailedMsg: 'Sitios no se pudieron agregar',
      problemWithRequest: 'There was a problem with the request.',
      newSubscriptionAdded: 'Nueva suscripción agregada',
      licensesOf: 'Licencias de',
      all: 'Todas',
      orderPlacedBy: 'Pedido realizado por',
      pendingRenewal: 'Renovación pendiente',
      daysRemaining: 'Días restantes',
      renewSubscriptionMessage:
        'Para renovar {{skuName}}, comuníquese con el centro de atención al cliente de Honeywell (+01 480-353-3020) o envíe un correo electrónico a support@honeywell.com',
      columnSelection: 'Selección de columnas',
      selectUpTo: 'Puede seleccionar hasta',
      itemsToDisplay: 'elementos para que se muestren en la tabla.',
      subscriptionManagement: 'Gestión de suscripciones',
      activated: 'Activado',
      warningHeader: '¿Está seguro de que desea cancelar?',
      warningMessage: 'Hay cambios sin guardar que se perderán',
      renewSubscription: 'Renovar la suscripción',
      pendingActivation: 'Activación pendiente',
      notAuthorizedError:
        'No está autorizado a asignar SKU a esta organización',
      gatewayRegistrationInProgress: '{{gateway}} en curso',
      gatewayAssociationFailed:
        'Compruebe la conectividad de la puerta de enlace e inténtelo otra vez. Si vuelve a producirse un error, póngase en contacto con su administrador de sistemas.',
      gatewayRegistrationFailed:
        'Vuelva a intentarlo. Si vuelve a producirse un error, póngase en contacto con su administrador de sistemas.',
      doAssociationMessage:
        'Please check gateway connectivity and proceed with gateway association.',
      errorInAssociation: 'Error en el procesamiento de la asociación.',
      association: 'Asociación',
      dataloseWarningForRegistration:
        'El registro de la puerta de enlace está en curso, puede que tardar unos minutos. No actualice para evitar pérdidas de datos.',
      dataloseWarningForAssociation:
        'El asociación de la puerta de enlace está en curso, puede que tardar unos minutos. No actualice para evitar pérdidas de datos.',
      objectName: 'Object Name',
      objectType: 'Object Type',
      unitName: 'Unidad',
      bitunpack: 'Bit Unpack',
      bitRange: 'Bit Range',
      propName: 'Prop Name',
      propDataType: 'Data Type',
      propValue: 'Prop Value',
      msgType: 'MESSAGE TYPE',
      isMultiState: 'Is Multi State',
      scalingOperation: 'Scaling Operation',
      scalingFactor: 'Scaling Factor',
      byteOrder: 'Byte Order',
      propertyName: 'Property Name',
      addTemplateSuccess: 'Plantilla agregada con éxito',
      addTemplateError: 'No se pudo agregar plantilla.Inténtalo de nuevo.',
      updateTemplateSuccess: 'Plantilla actualizada con éxito',
      updateTemplateError:
        'No se pudo actualizar la plantilla.Inténtalo de nuevo.',
      outOfRangeError: 'El valor debe estar entre {{min}} y {{max}}',
      requiredField: 'Por favor llene todos los campos',
      templateName: 'Nombre de la plantilla',
      modelName: 'Nombre del modelo',
      vendorName: 'Nombre del proveedor',
      uniqueValueError: 'El valor debe ser único',
      templateMangement: 'Gestión de plantillas',
      equipmentType: 'Tipo de equipo',
      selectType: 'Seleccionar tipo',
      listOfTemplate: 'Lista de plantilla',
      selectTemplate: 'Seleccionar plantilla',
      ElectricityVoltage: 'Voltaje de electricidad',
      ElectricityCurrent: 'Corriente eléctrica',
      ElectricPowerFactor: 'Factor eléctrico',
      ElectricFrequency: 'Frecuencia eléctrica',
      EnergyReceived: 'Energía recibida',
      ActivePower: 'Poder activo',
      ActivePowerA: 'Potencia activa A',
      ActivePowerB: 'Potencia activa B',
      ActivePowerC: 'Potencia activa C',
      ReactivePower: 'Poder reactivo',
      ApparentPower: 'Poder aparente',
      PeakDemand: 'La demanda máxima',
      ElectricityCurrentA: 'Corriente de electricidad A',
      ElectricityCurrentB: 'Corriente de electricidad B',
      ElectricityCurrentC: 'Corriente de electricidad c',
      ElectricityVoltageA: 'Voltaje de electricidad A',
      ElectricityVoltageB: 'Voltaje de electricidad B',
      ElectricityVoltageC: 'Voltaje de electricidad C',
      ElectricityConsumption: 'Consumo de electricidad',
      loaderWelcomeMessage: 'Bienvenido al Portal de Incorporación. Aguarde.',
      latitudeAndLongitude: 'Latitud & Longitud',
      siteUpdateSuccessMessage:
        'Los detalles del sitio se han actualizado correctamente',
      siteUpdateErrorMessage: 'Error al actualizar los detalles del sitio',
      provisioningFailedMessages:
        'Error de aprovisionamiento del sitio. Vuelva a intentarlo',
      onboardAllSites: 'Incorporar todos los sitios',
      geoCordinatesErrorMsg: 'Compruebe las coordenadas',
      tooltipCordinateMessage: 'las coordenadas deben estar entre',
      emptyValueMessage: 'No se permite un valor vacío',

      browseFile: 'Browse File',
      fileTypeErrorMsg: 'File type is not allowed',

      orgImgTitle: 'Upload Organization Logo',
      orgImgDropTxt: 'Drag and Drop Logo',
      orgImgInfoTxt:
        'W {{width}}px X H {{height}}px and Only *.png file format',
      orgImgPreviewTxt: 'Preview Logo',
      orgImgTooltipTxt:
        'Logo to have transparent background and should contrast black header background',
      orgImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, max height {{height}}px, minimum width {{minWidth}}px, minimum height {{minHeight}}px and max size {{maxSize}}kb',

      siteImgTitle: 'Upload Site image',
      siteImgDropTxt: 'Drag and Drop Building image (*.png or .jpg)',
      siteImgPreviewTxt: 'Preview Site Details Page',
      siteTooltipTxt:
        'Image will be cropped 46px on right & left and 30px on top & bottom part of the image based on different monitor resolution',
      siteImgInfoTxt:
        'W {{width}}px X H {{height}}px and *.png & *.jpg file format',
      siteImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, height {{height}}px and size {{maxSize}}kb',
      orTxt: 'Or',
      addLogo: 'Add Logo',
      addImage: 'Add Image',
      imageUploadSuccess: 'Image Uploaded Successfully',
      alertnteId: 'Nombre de usuario alternativo:',
      username: 'nombre de usuario:',
      errorFetchingUser: 'Error al recuperar la lista de usuarios',
      errorFetchingRoles: 'Error al recuperar funciones',

      gateway: 'GATEWAY',
      associateAndSyncBtn: 'ASOCIAR & SINCRONIZAR',
      cancelBtn: 'CANCELAR',
      guidValidationError: 'Error de validación de GUID',
      gatewayId: 'ID DE GATEWAY',
      addNewGateway: 'Agregar nueva gateway',
      successMessage1: 'Asociación del sitio, completada',
      successMessage2:
        'Asociación del sitio, completada. Se iniciará la sincronización del modelo',
      errorMessage:
        'Asociación fallida, la sincronización del modelo no se iniciará',
      importUsers: 'Importar usuarios',
      importUsersSubHeading:
        'Agregue y administre lo que desea importar descargando la plantilla CSV.',
      dropCsvHere: 'Arrastra y suelta el archivo aquí o',
      browsrForFiles: 'Buscar archivos',
      subHeadingBrowser:
        'Solo se aceptan archivos CSV y el archivo no debe exceder los 5 MB.',
      subHeadingBrowserTwo: '(solo una carga posible a la vez)',
      userUploadSuccess: 'Datos enviados exitosamente',
      userUploadProcessing:
        'Los datos se han subido correctamente. Actualmente estamos procesando y tomará unos minutos. Lo actualizaremos pronto.',
      fileNameDisplay: 'Nombre del archivo :',
      fileName: 'Nombre del archivo',
      errorNotification:
        'Encontramos un problema al cargar la plantilla. Rectifique los errores a continuación y vuelva a cargar la plantilla.',
      errorHeading: 'Error',
      slnumber: 'SL núm.',
      errorMessageHeading: 'MENSAJE DE ERROR',
      endUserAgreement: 'Términos de Honeywell Forge',
      privacyStatement: 'Declaración de Privacidad',
      yourPrivacyChoices: 'Sus opciones de privacidad',
      cookieNotice: 'Aviso de cookies',
      dataCentre: 'Centro de datos',
      isForgeText: 'Edificios',
      gatewayIdleMessage:
        'Has estado inactivo durante unos minutos, actualiza la página para continuar.',
      refresh: 'Actualizar',
      landingLogin: 'Haga clic aquí',
      loginUserIntegratorRole: 'Usuarios de comercio electrónico de BA',
      loginUserCustomerRole: 'Todos los demás usuarios',
      loginWelcomeNote:
        'Bienvenido, elija su rol a continuación para comenzar.',
      termsAndConditions: 'Términos y condiciones',
      accept: 'Aceptar',
      legalPatentInformation: 'Información legal de patentes',
      onboardingPortal: 'Portal de incorporación',
      customers: 'Clientes',
      templates: 'Plantillas',
      assetModelling: 'Modelo de activos',
      selectCustomer: 'Seleccionar cliente',
      integration: 'Integración',
      integrationSubtitle:
        'Integre sin problemas para obtener información de rendimiento en tiempo real',
      customer: 'Cliente',
      accessibleCustomersError: 'Error al obtener los clientes accesibles',
      workflows: 'Flujos de trabajo (heredados)',
      apiCredentials: 'Credenciales de API',
      integrationsTab: 'Flujos de trabajo',
      noSubscription:
        'No se encontró una suscripción activa. Suscríbase para acceder a esta función.',
      loading: 'Cargando...',
      licenseManagement: 'Gestión de licencias',
      activityLogTitle: 'Registros de actividad',
      activityLogSubtitle:
        'Monitorear eventos de flujo de trabajo y actualizaciones de estado para los clientes seleccionados',
      activityLogSidebarTitle: 'Registros de actividad',
      activityLogSidebarSubtitle:
        'Estos son los datos de actividad de todas las organizaciones de clientes',
      activityLogListTitle: 'Lista de actividades',
      activityLogSearchPlaceholder: 'Buscar por actividad, sitio',
      activityLogLastUpdated: 'Última actualización',
      activityLogCreatedOn: 'Creado el',
      activityLogActivity: 'Actividad',
      activityLogSite: 'Sitio',
      activityLogStatus: 'Estado',
      activityLogCreatedBy: 'Creado por',
      activityLogUpdatedBy: 'Actualizado por',
      activityLogNameUnavailable: 'Nombre no disponible',
      activityLogUserNamesError:
        'No se pudieron cargar los nombres de CreadoPor/ActualizadoPor',
      activityLogStatusSuccess: 'Éxito',
      activityLogStatusFailed: 'Error',
      activityLogStatusInProgress: 'En curso',
      activityLogStatusQueued: 'En cola',
      activityLogStatusPending: 'Pendiente',
      activityLogStatusSkipped: 'Omitido',
      activityLogPaginationInfo:
        '{startItem} - {endItem} de {totalItems} elementos',
      activityLogPageGoTo: 'Ir a la página',
      activityLogRowPerPage: 'Filas por página',
      activityLogRetry: 'Reintentar',
      activityLogRetrying: 'Reintentando...',
      activityLogRetrySuccess: 'Reintento de tarea iniciado con éxito.',
      activityLogRetryError:
        'No se pudieron cargar las opciones de filtro. Inténtelo de nuevo.',
      activityLogRetryAllSuccess:
        'Todas las tareas se han reintentado correctamente.',
      activityLogRetryAllFailed:
        'Todos los reintentos han fallado. Inténtelo de nuevo.',
      activityLogRetryPartialFailed:
        'Algunas tareas no se pudieron reintentar. Inténtelo de nuevo.',
      activityLogLoading: 'Cargando detalles...',
      activityLogFetchError:
        'No se pudieron cargar los datos de actividad. Inténtelo de nuevo.',
      activityLogModalClose: 'Cerrar',
      activityLogModalTasks: 'Tareas',
      activityLogModalCreatedOn: 'Creado el',
      activityLogModalLastUpdatedOn: 'Última actualización el',
      activityLogModalSupportNote:
        'Descripción del evento de fallo y el código de motivo.',
      activityLogModalSupportReach:
        'Para obtener asistencia, póngase en contacto con',
      activityLogModalSupportEmail: 'connectedbuildingsupport@honeywell.com',
      activityLogFilterTitle: 'Filtrar por',
      noCustomersAvailable: 'No hay clientes disponibles',
      activityLogFilterStatus: 'Estado',
      activityLogFilterActivity: 'Actividad',
      activityLogFilterSite: 'Sitio',
      activityLogFilterCreatedBy: 'Creado por',
      activityLogFilterApply: 'Aplicar',
      activityLogFilterReset: 'Restablecer',
      activityLogFilterNoOptions: 'No hay opciones disponibles',
      activityLogFilterError:
        'No se han cargado las opciones de filtro. Por favor, inténtalo de nuevo.',
      search: 'Buscar',
      more: 'más',
      noResults: 'No se han encontrado resultados',
      activityLogCustomizeColumns: 'Personalizar columnas',
      activityLogColumnsReorder: 'Reordenar',
      activityLogColumnsAddRemove: 'Añadir/Eliminar',
      activityLogColumnsReorderDescription:
        'Reposicione para cambiar el orden de las columnas de la tabla',
      activityLogColumnsAddRemoveDescription:
        'Seleccione las columnas para mostrarlas en la tabla',
      activityLogDetails: 'Detalles',
      activityLogFiltersChanged:
        'No se encontraron datos para los filtros seleccionados. Ajuste o restablezca los filtros para ver resultados.',
      activityLogResetFilters: 'Restablecer filtros',
      activityLogSiteState: 'Estado',
      activityLogSiteCity: 'Ciudad',
      workflowTaskCBCustomerCreation: 'Creación de cliente en CB',
      workflowTaskOnboardingStatusUpdatePartnerPortal:
        'Actualización del estado de incorporación en el portal de socios',
      workflowTaskUpdateCBCustomerIdPartnerPortal:
        'Actualizar el ID de cliente de CB en el portal de socios',
      workflowTaskEOMCustomerCreation: 'Creación de cliente en EOM',
      workflowTaskOnboardCustomerForAI: 'Incorporar cliente para IA',
      workflowTaskDeleteCustomerInCBPortal: 'Eliminar cliente en el portal CB',
      workflowTaskUpdateCustomerInCBPortal:
        'Actualizar el cliente en el Portal de CB',
      workflowTaskUpdateCustomerInEOM: 'Actualizar el cliente en EOM',
      workflowTaskUpdateCustomerInAssetModelling:
        'Actualizar organización en modelado de activos',
      workflowTaskTrackScanStatusFileAttachment:
        'Seguimiento del estado de escaneo de archivos adjuntos',
      workflowTaskCBSiteCreation: 'Creación de sitio en CB',
      workflowTaskUpdateCBSiteIdPartnerPortal:
        'Actualizar el ID del sitio CB en el portal de socios',
      workflowTaskEOMSiteCreation: 'Creación de sitio en EOM',
      workflowTaskUpdateEOMSiteIdPartnerPortal:
        'Actualizar el ID del sitio de EOM en el portal de socios',
      workflowTaskSyncExistingUsersCBPortal:
        'Sincronizar usuarios existentes con CB Portal',
      workflowTaskUpdateUserSyncStatusPartnerPortal:
        'Actualizar el estado de sincronización de usuario en el portal de socios',
      workflowTaskCalculateEnergySavingsPotential:
        'Calcular el potencial de ahorro energético',
      workflowTaskDeleteSiteInCBPortal: 'Eliminar sitio en el portal CB',
      workflowTaskDeleteSiteInEOM: 'Eliminar sitio en EOM',
      workflowTaskUpdateSiteInCBPortal:
        'Actualizar el sitio en el Portal de CB',
      workflowTaskUpdateSiteInEOM: 'Actualizar el sitio en EOM',
      workflowTaskUpdateSiteInAssetModelling:
        'Actualizar sitio en modelado de activos',
      workflowTaskUpdateSiteInFindAPI: 'Actualizar el sitio en Buscar API',
      workflowTaskSyncSubscriptionAssociationCBPortal:
        'Sincronizar la asociación de suscripción con el Portal CB',
      workflowTaskEnableBrickOntology: 'Habilitar la ontología Brick',
      workflowTaskOnboardCustomerForgeAPI: 'Incorporar cliente a ForgeAPI',
      workflowTaskPublishForgeAPIOnboardingStatus:
        'Publicar el estado de incorporación de ForgeAPI en la gestión de credenciales',
      workflowTaskAddUserInCBPortal: 'Añadir usuario en el portal CB',
      workflowTaskUpdateUserProvisioningStatus:
        'Actualizar el estado de aprovisionamiento del usuario',
      workflowTaskDeleteUserInCBPortal: 'Eliminar usuario en el portal de CB',
      workflowTaskUpdateUserDeletionStatus:
        'Actualizar el estado de eliminación de usuario',
      workflowCustomerCreation: 'Creación de cliente',
      workflowCustomerDelete: 'Eliminación de cliente',
      workflowCustomerUpdate: 'Actualización de cliente',
      workflowFileAttachmentsScan: 'Estado de análisis de archivos adjuntos',
      workflowSiteCreation: 'Creación de sitio',
      workflowSiteDelete: 'Eliminación de sitio',
      workflowSiteUpdate: 'Actualización de sitio',
      workflowSubscriptionAssociation: 'Asociación de suscripción',
      workflowAddUser: 'Agregar usuario',
      workflowDeleteUser: 'Eliminar usuario',
      workflowNamePlate: 'Placa de identificación',
      workflowForgeAPIOnboarding: 'Incorporación a la API de Forge',
      workflowAddUserMultiple:
        'Flujo de trabajo para añadir múltiples usuarios',
      workflowDeleteUserMultiple:
        'Flujo de trabajo para eliminar múltiples usuarios',
      workflowModelFileUpload: 'Cargar archivo de modelo',
      workflowGatewayAssociation: 'Asociación de puerta de enlace',
      workflowIntegrationRegistered: 'Integración registrada',
      workflowTaskForgeAPIOnboardingStatus:
        'Estado de incorporación a APIForge',
      workflowTaskAddUser: 'Flujo de trabajo para añadir usuarios',
      workflowTaskProcessModelFile: 'Archivo de modelo de proceso',
      workflowTaskNotifyAssetModelling: 'Notificar modelado de activos',
      workflowTaskAssociateGateway: 'Asociar puerta de enlace al sitio',
      workflowTaskFetchModelToAssetModelling:
        'Obtener modelo para la modelización de activos',
      workflowTaskNameProcessNamePlate:
        'Procesar archivo de placa de identificación.',
      workflowTaskUpdateModelInFindAPI: 'Actualizar el modelo en Buscar API',
      workflowTaskProcessIntegrationRegistered: 'Integración registrada',
      workflowTaskProcessDFNotificationIntegrationRegistered:
        'Procesar notificación DF para integración registrada',
      workflowTaskTenantOnboardingAFO:
        'Incorporación de una organización a AFO',
      workflowTaskOnboardCustomerCDL: 'Incorporar cliente para CDL',
      workflowTaskPublishAFOOnboardingStatus: 'Publicar el estado de incorporación a AFO en el servicio Rule Builder',
      activityLogCorrelationId: 'ID de correlación',
      activityLogTaskId: 'ID de tarea',
      activityLogToastSuccess: 'Éxito',
      activityLogToastError: 'Error',
      activityLogIteration: 'Repetición',
      activityLogFieldFirstName: 'Nombre',
      activityLogFieldLastName: 'Apellidos',
      activityLogFieldSubscriptionName: 'Nombre de la suscripción',
      activityLogFieldName: 'Nombre',
      activityLogFieldCurrency: 'Divisa',
      activityLogFieldZip: 'CP',
      activityLogFieldArea: 'Área',
      activityLogFieldCity: 'Ciudad',
      activityLogFieldState: 'Estado',
      activityLogFieldCountry: 'País',
      activityLogFieldAreaUnit: 'Unidad de área',
      activityLogFieldLanguage: 'Idioma',
      activityLogFieldLatitude: 'Latitud',
      activityLogFieldSiteType: 'Tipo de sitio',
      activityLogFieldTimezone: 'Zona horaria',
      activityLogFieldLongitude: 'Longitud',
      activityLogFieldCountryCode: 'Código de país',
      activityLogFieldSiteId: 'ID sitio',
      activityLogFieldFileType: 'Tipo de archivo',
      activityLogFieldReason: 'Motivo',
      activityLogFieldCustomerSupportEmails: 'Correos electrónicos de atención al cliente',
      activityLogFieldAddressLine1: 'Dirección (línea 1)',
      activityLogFieldAddressLine2: 'Dirección (línea 2)',
      activityLogFieldContactEmail: 'Correo electrónico de contacto',
      activityLogSiTitle: 'Registro de actividad',
      support: 'Soporte',
      projectManagement: 'Gestión de proyectos',
    }
  }
};
